import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'file-context-menu',
  template: require('./file.context.menu.html')
})
export class FileContextMenuComponent implements OnInit {
  @Input() file: any;

  @Output() onRename = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();
  @Output() onMonitor = new EventEmitter<any>();
  @Output() onOrganizer = new EventEmitter<any>();
  @Output() onLock = new EventEmitter<any>();
  @Output() onUnzip = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  baseUrl: string;
  fileUrl: string;

  constructor(private window: Window) {}

  ngOnInit() {
    this.baseUrl = `${this.window.location.protocol}//${this.window.location.host}`;

    // Create URL for the latest version of the document
    this.fileUrl = `${this.baseUrl}${this.file.url.split('?')[0]}?version=latest`;
  }

  unlockText() {
    const fileLockedById = _.get(this.file, 'docmanFile.lockedBy.id', 0);
    const currentUserId = _.get(this.window, 'currentUser.id', -1);
    return fileLockedById === currentUserId ? 'Unlock File' : 'Force Unlock File';
  }

  rename() {
    this.onRename.emit(this.file);
  }

  edit() {
    this.onEdit.emit(this.file);
  }

  monitor() {
    this.onMonitor.emit(this.file.docmanFile);
  }

  organizer() {
    this.onOrganizer.emit(this.file);
  }

  lock() {
    this.onLock.emit(this.file.docmanFile);
  }

  unzip() {
    this.onUnzip.emit(this.file);
  }

  delete() {
    this.onDelete.emit(this.file);
  }
}
